import { asBoolean, loadedDefinedMap, asString } from "common/components/component-helpers";
import { ActionSource } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import SharePage from "webapp/chrome/smart/share-page/share-page";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";

export const ShareScreenMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[titlePV, authorPV, displayQRCodePV, onFeedbackPV, onReportPV]] = useForceValueProducers(
        getValueProducers,
        force,
        ctx
    );
    const { onClick: onFeedbackCB } = useOnClickFromAction(onFeedbackPV, ActionSource.None, ctx, env);
    const { onClick: onReportCB } = useOnClickFromAction(onReportPV, ActionSource.None, ctx, env);

    const title = loadedDefinedMap(titlePV, asString);
    const author = loadedDefinedMap(authorPV, asString);
    const displayQRCode = loadedDefinedMap(displayQRCodePV, asBoolean) ?? false;

    const onFeedback = onFeedbackCB !== undefined ? () => onFeedbackCB(undefined) : undefined;
    const onReport = onReportCB !== undefined ? () => onReportCB(undefined) : undefined;

    return (
        <SharePage
            title={title}
            author={author}
            displayQRCode={displayQRCode}
            renderEnvironment={env}
            onFeedback={onFeedback}
            onReport={onReport}
        />
    );
};
